import React, { Component } from "react";
import qs from "qs";
import _ from "lodash";
import ForgotClinicPasswordView from "./ForgotClinicPasswordView";
import {
  history,
  decryptId,
  encryptId,
  handleRedirectUserToSelectedPage,
  setPhoneLimit
} from "../../../helpers";
import { resetPasswordInstructions } from "../../../services";
import { defaultCountryObj } from "../../../helpers/CountryCodeOptions";

class ForgotClinicPasswordContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      errorMsg: "",
      phoneNumber: "",
      countryCode: defaultCountryObj?.country_code,
      serverError: false,
      utmSource: null,
      utmMedium: null,
      utmContent: null,
      utmCampaign: null,
      inviteCode: null,
      doctorName: null,
      docId: null,
      hasForgot: false,
      isProcessing: false,
      accountType: null,
      signupIntent: null,
      testValue: null
    };
  }

  componentDidMount() {
    this.fetchUTMParams();
  }

  /**
   * @function forgotPasswordAction
   * @param countryCode
   * @param phoneNumber
   * @desc This function takes in the phone number and send verification
   *  code to user, to allow user to change the password
   */

  forgotPasswordAction = (countryCode, phoneNumber) => {
    this.setState({ isProcessing: true });
    resetPasswordInstructions(countryCode, phoneNumber).then(response => {
      this.setState({ isProcessing: false });
      if (response.data && response.data.success === true) {
        const responseObj = response.data;
        const userId = encryptId(responseObj.data.id);
        this.setState({
          hasForgot: true,
          userId
        });
      } else {
        this.setState({
          hasForgot: true
        });
      }
    });
  };

  /**
   * @function fetchUTMParams
   * @desc This funtion fetches utm params in url
   */
  fetchUTMParams = () => {
    const params = qs.parse(this.props.location.search.slice(1));

    if (params && !_.isEmpty(params)) {
      const {
        utm_source,
        utm_medium,
        utm_content,
        utm_campaign,
        kic,
        dname,
        did,
        acc,
        su_int,
        a6t
      } = params;
      this.setState({
        utmSource: utm_source || null,
        utmMedium: utm_medium || null,
        utmContent: utm_content || null,
        utmCampaign: utm_campaign || null,
        inviteCode: kic || null,
        doctorName: dname || null,
        docId: did ? decryptId(did) : null,
        accountType: acc || null,
        signupIntent: su_int || null,
        testValue: a6t || null
      });
    }
  };

  /**
   * @function handleChange
   * @param e
   * @return nothing
   * @desc This method handles input changes in forgot password screen
   */
  handleChange = e => {
    const { name, value } = e.target;
    this.setState({
      [name]: value.replace(/\s/g, ""),
      error: false,
      errorMsg: "",
      serverError: false,
      isProcessing: false
    });
  };

  /**
   * @function setStateForInvalidData
   * @param errorText
   * @return nothing
   * @desc This method sets error messages state
   */
  setStateForInvalidData = errorText => {
    this.setState({
      error: true,
      errorMsg: errorText,
      serverError: false
    });
  };

  /**
   * @function handleSubmit
   * @param e
   * @return nothing
   * @desc This method checks for valid input and
   * submits phone number so that user
   *  recieved the verification code to
   *  change the password
   */
  handleSubmit = e => {
    e.preventDefault();

    const { phoneNumber, countryCode } = this.state;

    if (!phoneNumber) {
      this.setStateForInvalidData("required_phone_number");
      return;
    }

    if (phoneNumber && countryCode) {
      this.forgotPasswordAction(countryCode, phoneNumber);
    } else {
      this.setStateForInvalidData("param_missing");
    }
  };

  /**
   * @function handleResendCode
   * @param e
   * @return nothing
   * @desc This method handles resend verification code
   */
  handleResendCode = e => {
    e.preventDefault();
    const { phoneNumber, countryCode } = this.state;
    this.props.resendCode(phoneNumber, countryCode);
  };

  /**
   * @function handleCancel
   * @param e
   * @param nothing
   * @desc This handles redirection to sign in page
   */
  handleCancel = () => {
    history.push("/sign-in");
  };

  /**
   * @function goToSignIn
   * @desc This function handles redirection to given page
   */
  goToSignIn = e => {
    if (e) e.preventDefault();
    let redirectUrl = "signin";
    const {
      utmSource,
      utmMedium,
      utmContent,
      utmCampaign,
      inviteCode,
      doctorName,
      docId,
      accountType,
      signupIntent,
      testValue
    } = this.state;

    const params = {
      utmSource,
      utmMedium,
      utmContent,
      utmCampaign,
      inviteCode,
      doctorName,
      docId,
      accountType,
      signupIntent,
      testValue
    };
    handleRedirectUserToSelectedPage(redirectUrl, params);
  };

  handleCodeChange = countryCode => {
    this.setState({
      phoneNumberLengthLimit: setPhoneLimit[countryCode],
      countryCode
    });
  };

  render() {
    const { hasForgot, countryCode, accountType } = this.state;
    return (
      <ForgotClinicPasswordView
        handleChange={this.handleChange}
        handleSubmit={this.handleSubmit}
        handleCancel={this.handleCancel}
        isProcessing={this.state.isProcessing}
        error={this.state.error}
        errorMsg={this.state.errorMsg}
        forgotPasswordError={this.props.forgotPasswordError}
        serverError={this.state.serverError}
        phoneNumber={this.state.phoneNumber}
        goToSignIn={this.goToSignIn}
        countryCode={countryCode}
        hasForgot={hasForgot}
        userId={this.state.userId}
        handleCodeChange={this.handleCodeChange}
        accountType={accountType}
      />
    );
  }
}

export default ForgotClinicPasswordContainer;
